import React from 'react';
import { motion } from 'framer-motion';
import { Activity, BarChart2, ShieldAlert, TrendingUp, TrendingDown } from 'lucide-react';
const metrics = [{
  label: 'Sharpe Ratio',
  value: '1.84',
  badge: 'Good',
  badgeColor: 'bg-success/10 text-success',
  icon: <Activity size={16} className="text-brand-purple-light" data-id="element-93" />,
  valueColor: 'text-text-primary'
}, {
  label: 'Leverage Efficiency',
  value: '78.4%',
  badge: 'Optimal',
  badgeColor: 'bg-success/10 text-success',
  icon: <BarChart2 size={16} className="text-brand-purple-light" data-id="element-94" />,
  valueColor: 'text-text-primary'
}, {
  label: 'Long Win Rate',
  value: '72.1%',
  icon: <TrendingUp size={16} className="text-success" data-id="element-95" />,
  valueColor: 'text-success'
}, {
  label: 'Short Win Rate',
  value: '58.3%',
  icon: <TrendingDown size={16} className="text-brand-purple-light" data-id="element-96" />,
  valueColor: 'text-text-primary'
}, {
  label: 'Avg Leverage',
  value: '8.4x',
  icon: <Activity size={16} className="text-brand-purple-light" data-id="element-97" />,
  valueColor: 'text-text-primary'
}, {
  label: 'Liquidations',
  value: '0',
  badge: 'Safe',
  badgeColor: 'bg-success/10 text-success',
  icon: <ShieldAlert size={16} className="text-success" data-id="element-98" />,
  valueColor: 'text-success'
}];
export function FuturesRiskMetrics() {
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-99">
      {metrics.map((metric, i) => <motion.div key={metric.label} initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.35,
      delay: i * 0.06
    }} className="glass-border rounded-[20px] p-4" data-id="element-100">
          <div className="flex items-center justify-between mb-2" data-id="element-101">
            <span className="text-[10px] font-label text-text-tertiary uppercase" data-id="element-102">
              {metric.label}
            </span>
            <div className="p-1.5 bg-background-elevated rounded-lg" data-id="element-103">
              {metric.icon}
            </div>
          </div>
          <div className="flex items-center gap-2" data-id="element-104">
            <span className={`text-xl font-numbers font-light ${metric.valueColor}`} data-id="element-105">
              {metric.value}
            </span>
            {metric.badge && <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full ${metric.badgeColor}`} data-id="element-106">
                {metric.badge}
              </span>}
          </div>
        </motion.div>)}
    </div>;
}